module.exports = __webpack_public_path__ + "img/header_logo_predixon.f3155509.png";